<template>
  <div style="background: #ffffff;">
    <Toolbar
      :id="containerId"
      :type="type"
      @onInsert="handleInsertTag"
    />
    <quill-editor
      @change="handleChange"
      ref="myQuillEditor"
      :options="getOptions()"
      style="margin-bottom: 10px;"
    />
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';

  import Quill from 'quill';
  import TemplateMarker from './TemplateMarker';
  import { quillEditor } from 'vue-quill-editor';
  import Toolbar from './Toolbar';

  export default {
    props: ['content', 'type'],
    data() {
      return {
        containerId: `toolbar${Math.round(Math.random() * 10000)}`,
      };
    },
    methods: {
      handleChange({ quill }) {
        const delta = quill.getContents();
        this.$emit('change', delta);
      },
      handleInsertTag(tag, index) {
        const quill = this.$refs.myQuillEditor.quill;
        const range = quill.getSelection(true);

        quill.insertEmbed(
          range.index,
          'TemplateMarker',
          {
            colour: 'primary',
            marker: tag.value,
            title: tag.label,
          },
        );

        quill.insertText((index || range.index) + 1, ' ', Quill.sources.USER);
        quill.setSelection((index || range.index) + 2, Quill.sources.SILENT);
      },
      getOptions() {
        return {
          placeholder: '',
          modules: {
            history: {
              delay: 2000,
              maxStack: 500,
              userOnly: true,
            },
            toolbar: {
              container: '#' + this.containerId,
            },
          },
        };
      },
    },
    mounted() {
      const template = TemplateMarker.call(this);
      Quill.register({
        'formats/TemplateMarker': template,
      });
      const quill = this.$refs.myQuillEditor.quill;
      quill.setContents(this.content, 'api');
    },
    components: {
      quillEditor,
      Toolbar,
    },
  };
</script>

<style>
  .badge {
    display: inline-block;
    padding: .2em .4em;
    font-size: 85%;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25rem;
  }

  .badge-warning {
    color: #e6a23c;
    background-color: rgba(230, 162, 60, .1);
    border: 1px solid rgba(230, 162, 60, .2);
  }

  .badge-primary {
    color: #409eff;
    background-color: rgba(64, 158, 255, .1);
    border: 1px solid rgba(64, 158, 255, .2);
  }

  .ql-container.ql-snow {
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  .ql-toolbar.ql-snow {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom: none;
  }
</style>
